import React, { useState } from "react";
import "../styles/ReportModal.css";

const ReportModal = ({ isOpen, onClose, facilities, filters }) => {
  const [format, setFormat] = useState("csv");

  if (!isOpen) return null;

  const downloadCSV = () => {
    const data = facilities.map((facility) => ({
      "Facility Name": facility.facilityName || "",
      Company: facility.company || "",
      Address: facility.address || "",
      City: facility.city || "",
      County: facility.county || "",
      "Industry Sector": facility.industrySector || "",
      Chemical: facility.chemical || "",
      Carcinogen:
        facility.carcinogen === "Yes" ||
        facility.carcinogen === true ||
        facility.isCarcinogen === "Yes" ||
        facility.isCarcinogen === true
          ? "Yes"
          : "No",
      Latitude: facility.latitude || "",
      Longitude: facility.longitude || "",
      "Air Releases (lbs)":
        facility.airReleases || facility.air_releases || "0",
      "Water Releases (lbs)":
        facility.waterReleases || facility.water_releases || "0",
      "Land Releases (lbs)":
        facility.landReleases || facility.land_releases || "0",
      "Total Releases (lbs)":
        facility.totalReleases || facility.total_releases || "",
    }));

    const headers = Object.keys(data[0]);
    const csvContent = [
      headers.join(","),
      ...data.map((row) =>
        headers
          .map((header) => {
            const value = String(row[header] || "");
            // Escape quotes and wrap in quotes if contains comma
            return value.includes(",") || value.includes('"')
              ? `"${value.replace(/"/g, '""')}"`
              : value;
          })
          .join(",")
      ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `michigan-toxic-releases-${
      new Date().toISOString().split("T")[0]
    }.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const downloadJSON = () => {
    const jsonContent = JSON.stringify(facilities, null, 2);
    const blob = new Blob([jsonContent], { type: "application/json" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `michigan-toxic-releases-${
      new Date().toISOString().split("T")[0]
    }.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleDownload = () => {
    if (format === "csv") {
      downloadCSV();
    } else if (format === "json") {
      downloadJSON();
    }
    onClose();
  };

  const getActiveFilters = () => {
    const active = [];
    if (filters.county !== "all") active.push(`County: ${filters.county}`);
    if (filters.industry !== "all")
      active.push(`Industry: ${filters.industry}`);
    if (filters.carcinogen === "yes") active.push("Carcinogen Only");
    if (filters.carcinogen === "no") active.push("Non-Carcinogen Only");
    if (filters.searchTerm) active.push(`Search: "${filters.searchTerm}"`);
    return active;
  };

  const activeFilters = getActiveFilters();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ✕
        </button>

        <h2>📥 Download Report</h2>
        <p className="facility-count">
          <strong>{facilities.length.toLocaleString()}</strong> facilities match
          your current filters
        </p>

        <div className="format-selection">
          <h3>Select Format:</h3>
          <label className="format-option">
            <input
              type="radio"
              value="csv"
              checked={format === "csv"}
              onChange={(e) => setFormat(e.target.value)}
            />
            <div className="format-details">
              <strong>CSV (Spreadsheet)</strong>
              <span>Best for Excel, Google Sheets, data analysis</span>
            </div>
          </label>

          <label className="format-option">
            <input
              type="radio"
              value="json"
              checked={format === "json"}
              onChange={(e) => setFormat(e.target.value)}
            />
            <div className="format-details">
              <strong>JSON (Data)</strong>
              <span>Best for developers, APIs, programming</span>
            </div>
          </label>
        </div>

        {activeFilters.length > 0 && (
          <div className="filter-summary">
            <h3>Active Filters:</h3>
            <ul>
              {activeFilters.map((filter, index) => (
                <li key={index}>{filter}</li>
              ))}
            </ul>
          </div>
        )}

        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button className="download-button-primary" onClick={handleDownload}>
            Download {format.toUpperCase()}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportModal;
